import { siteInfo, heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-16 md:pt-18 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-secondary-50"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-4">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
              {siteInfo.tagline}
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 font-heading leading-tight tracking-tight">
              {siteInfo.name}
              <br />
              <span className="text-primary-500">{siteInfo.slogan}</span>
            </h1>

            <p className="mt-4 md:mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
              51每日大赛是国内领先的娱乐八卦与争议事件聚合平台，每日追踪明星塌房、网红翻车、综艺内幕等全网热点黑料。
              我们汇聚数百位线人与独立调查者的独家投稿，坚持多方交叉验证后发布，拒绝公关删帖，还原事件最真实的一面。
              当前重点聚焦选秀黑幕、顶流塌房与网红人设崩塌三大热点方向。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mt-5 md:mt-6">
              {heroStats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-lg md:text-xl font-black text-primary-500 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6 md:mt-7">
              <a
                href="#index"
                className="w-full sm:w-auto px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                立即吃瓜
              </a>
              <a
                href="#contact"
                className="w-full sm:w-auto px-6 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-md hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                爆料投稿
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20of%20breaking%20news%20and%20media%20chaos%2C%20warm%20crimson%20and%20dark%20amber%20tones%2C%20abstract%20composition%20with%20newspaper%20fragments%20and%20camera%20flashes%2C%20intense%20atmosphere%2C%20journalism%20theme%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20editorial%20style%2C%20high%20contrast%2C%20mysterious%20mood&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="51每日大赛 - 全网黑料吃瓜第一站"
                className="w-full h-full object-cover rounded-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-lg"></div>
              <div className="absolute bottom-3 left-4 right-4 flex gap-2">
                <span className="px-2 py-1 bg-primary-500/90 text-white text-xs font-semibold rounded">今日爆款</span>
                <span className="px-2 py-1 bg-black/50 text-white text-xs rounded">实时更新中</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}